import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionLaboratoryApi = {
    getTrialInstitutionLaboratories: (): Observable<Dtos.GetTrialInstitutionLaboratoriesResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratories = new Dtos.GetTrialInstitutionLaboratories();

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoriesByTrialInstitutionId: (trialInstitutionId?: number): Observable<Dtos.GetTrialInstitutionLaboratoriesByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoriesByTrialInstitutionId = new Dtos.GetTrialInstitutionLaboratoriesByTrialInstitutionId();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoriesByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoriesByTrialId: (trialId?: number): Observable<Dtos.GetTrialInstitutionLaboratoriesByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoriesByTrialId = new Dtos.GetTrialInstitutionLaboratoriesByTrialId();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoriesByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoryById: (id: number): Observable<Dtos.GetTrialInstitutionLaboratoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryById = new Dtos.GetTrialInstitutionLaboratoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoryByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetTrialInstitutionLaboratoryByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryByLaboratoryId = new Dtos.GetTrialInstitutionLaboratoryByLaboratoryId();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionLaboratory: (trialInstitutionLaboratory: Dtos.TrialInstitutionLaboratory): Observable<Dtos.SetTrialInstitutionLaboratoryResponse> => {

        let request: Dtos.SetTrialInstitutionLaboratory = new Dtos.SetTrialInstitutionLaboratory();

        request.trialInstitutionLaboratory = trialInstitutionLaboratory;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialInstitutionLaboratory: (laboratoryId: number | null, trialInstitutionId: number | null): Observable<Dtos.CreateTrialInstitutionLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionLaboratory = new Dtos.CreateTrialInstitutionLaboratory();

        request.laboratoryId = laboratoryId;
        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionLaboratoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteTrialInstitutionLaboratory: (id: number): Observable<Dtos.DeleteTrialInstitutionLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.DeleteTrialInstitutionLaboratory = new Dtos.DeleteTrialInstitutionLaboratory();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteTrialInstitutionLaboratoryResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionLaboratory: (trialInstitutionLaboratory: Dtos.TrialInstitutionLaboratory): Observable<Dtos.ValidateTrialInstitutionLaboratoryResponse> => {

        let request: Dtos.ValidateTrialInstitutionLaboratory = new Dtos.ValidateTrialInstitutionLaboratory();

        request.trialInstitutionLaboratory = trialInstitutionLaboratory;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    }
}